import React from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

export default function Loopster() {
  return (
    <div className="max-w-2xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-2">Loopster</h1>
      <div className="mb-2 flex items-center space-x-2 text-indigo-500 font-medium text-sm">
        <a
          href="https://loopster.l-uca.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1"
        >
          Website <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
        </a>
        <span className="text-gray-300">|</span>
        <a
          href="https://github.com/Luca-W-D/loopster"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1"
        >
          GitHub Repo <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
        </a>
      </div>

      <div className="mb-2 text-gray-700">
        Loopster is an open-source tool for generating Spotify playlists from
        your listening history. It helps you parse your previous listening
        history to identify songs you like together.
        <br />
        <br />
        The app is built with React and integrates with the Spotify REST API for
        playlist management and song search. Loopster is fully open-source and
        hosted on Netlify for easy access and deployment.
      </div>
      <span className="inline-flex flex-wrap mb-4 gap-1">
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
          JavaScript
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          REST APIs
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          Infrastructure
        </span>
      </span>
      <div className="mb-8 p-3 bg-yellow-100 border-l-4 border-yellow-400 text-yellow-800 font-semibold rounded">
        ⚠️ The API used to play audio snippets was deprecated by Spotify.
      </div>

      <div className="mb-6">
        <h2 className="font-semibold text-base mb-1">How It Works</h2>
        <ul className="list-disc ml-6 text-gray-700">
          <li>A user uploads their Spotify 12-month listening history.</li>
          <li>
            Loopster analyzes groups of songs played without skipping, assuming
            these are songs you enjoy together.
          </li>
          <li>
            Loopster then allows users to listen through snippets of these
            clusters, finding songs they like and organizing them into playlists
          </li>
          <li>These playlists are then synced to their account</li>
        </ul>
      </div>

      <div className="mb-6">
        <h2 className="font-semibold text-base mb-1">Features</h2>
        <ul className="list-disc ml-6 text-gray-700">
          <li>Import songs from your Spotify library or search results</li>
          <li>
            Automatically upload generated playlists to your Spotify account
          </li>
          <li>Open-source and self-hostable</li>
          <li>Web app published on Netlify</li>
        </ul>
      </div>
    </div>
  );
}
